import React from 'react';
import { useTranslation } from 'react-i18next';
import './Illustrations.css';

/**
 * Money in the account over the coming weeks, dipping below the safe line, with a heads-up.
 * @returns {JSX.Element} Decorative drawing
 */
function CashIllustration() {
  const { t } = useTranslation();

  return (
    <svg className="illustration" viewBox="0 0 320 220" aria-hidden="true" focusable="false">
      <rect className="ill-paper" x="20" y="20" width="280" height="180" rx="16" />
      <text className="ill-text ill-text-navy" x="42" y="52" fontSize="13">
        {t('illustrations.cash.title')}
      </text>

      <line className="ill-stroke-threshold" x1="42" y1="160" x2="278" y2="160" />
      <path className="ill-stroke-navy" d="M42 124 C 64 106, 86 100, 108 108 S 150 130, 172 116 S 200 104, 214 112" />
      <path className="ill-stroke-forecast" d="M214 112 C 232 122, 246 152, 258 174" />
      <circle className="ill-orange" cx="258" cy="174" r="6" />

      <rect className="ill-orange" x="170" y="42" width="112" height="46" rx="12" />
      <path className="ill-orange" d="M238 87 L 247 100 L 254 87 Z" />
      <text className="ill-text ill-text-white" x="226" y="61" fontSize="11" textAnchor="middle">
        {t('illustrations.cash.warningLine1')}
      </text>
      <text className="ill-text ill-text-white" x="226" y="77" fontSize="11" textAnchor="middle">
        {t('illustrations.cash.warningLine2')}
      </text>
    </svg>
  );
}

export default CashIllustration;
